export default from './DesktopCalculationsResult';



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/components/DesktopCalculationsResult/index.js